module.exports = require("npm:baconjs@0.7.82/dist/Bacon.js");